import deepmerge from 'deepmerge'
import {
  Experience,
  PaymentPolicyType,
  Mode,
  NodeType,
  TextAlignment,
  LayoutType,
  Orientation,
  Crop,
  ThumbnailsAlignment,
  Recurrence,
  DayOfWeek,
} from '@wix/ambassador-table-reservations-v1-experience/types'

import {DEFAULT_CURRENCY} from '../../utils/constants'

import {EDITOR_MOCK_RESERVATION_LOCATION_ID} from './reservationLocation'

const defaultRichContent = {
  nodes: [
    {
      type: NodeType.PARAGRAPH,
      id: 'gkfif300',
      nodes: [
        {
          type: NodeType.TEXT,
          id: '',
          nodes: [],
          textData: {
            text: 'Welcome guests with a full description of your dining event. Share details of the experience, activities, and information to help set expectations. You can also include the background or the story behind why the dining event was created, highlight the types of guests who usually attend, and add any extra information that builds excitement. ',
            decorations: [],
          },
        },
      ],
      paragraphData: {},
    },
    {
      type: NodeType.PARAGRAPH,
      id: 'mjxw6303',
      nodes: [],
      paragraphData: {
        textStyle: {
          textAlignment: TextAlignment.AUTO,
        },
      },
    },
    {
      type: NodeType.PARAGRAPH,
      id: '6tmi8304',
      nodes: [
        {
          type: NodeType.TEXT,
          id: '',
          nodes: [],
          textData: {
            text: 'Don’t forget to add quality photos—images of past dining events, activities, or your venue can make your Experience more inviting and increase reservations.',
            decorations: [],
          },
        },
      ],
      paragraphData: {},
    },
    {
      type: NodeType.PARAGRAPH,
      id: 'lu83g307',
      nodes: [],
      paragraphData: {
        textStyle: {
          textAlignment: TextAlignment.AUTO,
        },
      },
    },
    {
      type: NodeType.PARAGRAPH,
      id: 'q275t308',
      nodes: [
        {
          type: NodeType.TEXT,
          id: '',
          nodes: [],
          textData: {
            text: 'Customize this section in Experiences in the Business Manager.',
            decorations: [],
          },
        },
      ],
      paragraphData: {},
    },
    {
      type: NodeType.PARAGRAPH,
      id: 'kqj3t325',
      nodes: [],
      paragraphData: {},
    },
    {
      type: NodeType.GALLERY,
      id: 'ahw3e342',
      nodes: [],
      galleryData: {
        items: [
          {
            image: {
              media: {
                src: {
                  url: '1a0869_943f3e77568f4acf92ce896845644062~mv2.png',
                },
                width: 959,
                height: 962,
              },
            },
          },
          {
            image: {
              media: {
                src: {
                  url: '1a0869_7dae05362d20479dbe7b1d233f11fac0~mv2.png',
                },
                width: 982,
                height: 976,
              },
            },
          },
          {
            image: {
              media: {
                src: {
                  url: '1a0869_6ae5ef6d7b7445f9863b6b765edfc460~mv2.png',
                },
                width: 977,
                height: 976,
              },
            },
          },
        ],
        options: {
          layout: {
            type: LayoutType.GRID,
            horizontalScroll: false,
            orientation: Orientation.COLUMNS,
            numberOfColumns: 3,
          },
          item: {
            ratio: 1,
            crop: Crop.FILL,
          },
          thumbnails: {
            placement: ThumbnailsAlignment.NONE,
          },
        },
      },
    },
    {
      type: NodeType.PARAGRAPH,
      id: 'xl1bg448',
      nodes: [],
      paragraphData: {},
    },
  ],
  documentStyle: {},
}

const defaultExperience: Experience = {
  id: 'editor-mock-experience-id',
  reservationLocationId: EDITOR_MOCK_RESERVATION_LOCATION_ID,
  currency: DEFAULT_CURRENCY,
  configuration: {
    displayInfo: {
      name: 'name',
      shortDescription: 'shortDescription',
      coverImage: undefined,
      richContent: defaultRichContent,
    },
    paymentPolicy: {
      paymentPolicyType: PaymentPolicyType.FREE,
    },
    onlineReservations: {
      partySize: {
        min: 1,
        max: 6,
      },
      approval: {
        mode: Mode.AUTOMATIC,
      },
      businessSchedule: undefined,
    },
    visible: true,
  },
}

const experiences: Partial<Experience>[] = [
  {
    id: 'editor-mock-experience-id-1',
    configuration: {
      displayInfo: {
        name: 'Jazz and Dinner',
        shortDescription: 'A brief summary of this experience.',
        coverImage: {
          id: '1a0869_507c6862393746f3acbe00a1912a5ce3~mv2.png',
          url: '',
          height: 1024,
          width: 1024,
        },
      },
      paymentPolicy: {
        paymentPolicyType: PaymentPolicyType.PER_GUEST,
        perGuestOptions: {
          price: '10',
        },
      },
    },
  },
  {
    id: 'editor-mock-experience-id-2',
    configuration: {
      displayInfo: {
        name: 'Wine Tasting',
        shortDescription: 'A brief summary of this experience.',
        coverImage: {
          id: '1a0869_e0f89c6621314e108128871f0995707f~mv2.png',
          url: '',
          height: 1024,
          width: 1024,
        },
      },
      onlineReservations: {
        businessSchedule: {
          durationInMinutes: 120,
          entries: [
            {
              recurrence: Recurrence.WEEKLY,
              weeklyOptions: {
                startDate: '2027-07-19',
                startDaysAndTimes: [
                  {
                    day: DayOfWeek.MONDAY,
                    time: '12:00',
                  },
                  {
                    day: DayOfWeek.TUESDAY,
                    time: '12:00',
                  },
                ],
              },
            },
          ],
        },
      },
    },
  },
  {
    id: 'editor-mock-experience-id-3',
    configuration: {
      displayInfo: {
        name: 'Cooking Masterclass',
        shortDescription: 'A brief summary of this experience.',
        coverImage: {
          id: '1a0869_dfc0f89c0d404e2f8e34aa0a7ab81cbe~mv2.png',
          url: '',
          height: 1024,
          width: 1024,
        },
      },
      paymentPolicy: {
        paymentPolicyType: PaymentPolicyType.PER_GUEST,
        perGuestOptions: {
          price: '10',
        },
      },
      onlineReservations: {
        businessSchedule: {
          durationInMinutes: 120,
          entries: [
            {
              recurrence: Recurrence.ONE_TIME,
              oneTimeOptions: {
                startDate: '2027-07-19',
                startTime: '17:00',
              },
            },
          ],
        },
      },
    },
  },
  {
    id: 'editor-mock-experience-id-4',
    configuration: {
      displayInfo: {
        name: 'Tea Ceremony',
        shortDescription: 'Traditional tea ceremony with local blends.',
        coverImage: {
          id: '1a0869_943f3e77568f4acf92ce896845644062~mv2.png',
          url: '',
          height: 1024,
          width: 1024,
        },
      },
    },
  },
  {
    id: 'editor-mock-experience-id-5',
    configuration: {
      displayInfo: {
        name: 'Holiday Brunch',
        shortDescription: 'A festive brunch that already happened.',
        coverImage: {
          id: '1a0869_7dae05362d20479dbe7b1d233f11fac0~mv2.png',
          url: '',
          height: 1024,
          width: 1024,
        },
      },
      onlineReservations: {
        businessSchedule: {
          durationInMinutes: 180,
          entries: [
            {
              recurrence: Recurrence.ONE_TIME,
              oneTimeOptions: {
                startDate: '2024-12-25',
                startTime: '10:00',
              },
            },
          ],
        },
      },
    },
  },
  {
    id: 'editor-mock-experience-id-6',
    configuration: {
      displayInfo: {
        name: 'New Year Gala',
        shortDescription: 'A past New Year celebration dinner.',
        coverImage: {
          id: '1a0869_6ae5ef6d7b7445f9863b6b765edfc460~mv2.png',
          url: '',
          height: 1024,
          width: 1024,
        },
      },
      onlineReservations: {
        businessSchedule: {
          durationInMinutes: 240,
          entries: [
            {
              recurrence: Recurrence.ONE_TIME,
              oneTimeOptions: {
                startDate: '2024-01-01',
                startTime: '19:00',
              },
            },
          ],
        },
      },
    },
  },
]

export const experiencesMock = experiences.map((experience) =>
  deepmerge(defaultExperience, experience),
)
